<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col-sm-12 px-0 custom-form-main-label">
        {{$t('manage_user')}}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 px-0">
        <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="updateUserRoleform">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('name')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="fullname" type="text" class="form-control" v-bind:placeholder="$t('name')" name="fullname" id="fullname">
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('email')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="email" type="email" class="form-control" v-bind:placeholder="$t('email')" name="email" id="email">
            </div>
          </div>
          <div class="row mt-3" v-if="!isLoggedInUser">
            <div class="col-lg-12 custom-form-label">
              {{$t('permission_level')}}
            </div>
          </div>
          <div class="form-group row mt-1" v-if="!isLoggedInUser">
            <div class="col-lg-12">
              <select required class="form-control" v-bind:id="'select_assigned_group_' +  getId()">
                <option value="" style="">{{$t('select_permission_level')}}</option>
                <option v-for="group in groups" v-bind:value="group.Name">
                  {{ group.Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <select required class="form-control" v-bind:id="'select_language_' +  getId()">
                <option value="" style="">{{$t('select_language')}}</option>
                <option value="en-us">
                  English (United States)
                </option>
                <option value="no">
                  Norwegian
                </option>
                <option value="pt">
                  Portuguese
                </option>
                <option value="sv">
                  Swedish
                </option>
              </select>
            </div>
          </div>

          <div v-show="this.$store.isSuperAdmin()" class="form-group row mt-3">
            <div class="col-lg-12">
              <input-checkbox @input="setOverrideGoogleCalendarEnable" v-bind:id="'chk_enableGoogleCalendar_' +  getId()"
                              v-bind:name="'chk_enableGoogleCalendar_' +  getId()" v-bind:checked="isGoogleCalendarEnable"
                              v-bind:text="$store.translate('enable_calendar_sync')" class="mt-1"></input-checkbox>
            </div>
          </div>


          <div class="form-group row text-right">
            <div class="col-lg-12 mt-1">
              <button @click="updateRole" type="submit" class="btn skin primary-button mt-1"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row mt-3" v-show="$store.getInstallationType() != 'Education'">
      <div class="col-sm-12 px-0 custom-form-label">
        {{$t('link_users_teams')}} <info-note v-bind:text="$t('optionally_connecting_user_with_teams')"></info-note>
      </div>
    </div>
    <form id="linkTeamWithUserForm" name="linkTeamWithUserForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
      <div class="row" v-show="$store.getInstallationType() != 'Education'">
        <div class="form-group col-sm-12 px-0">
          <div class="row">
            <div class="col-sm-12 mt-1">
              <team-select-selector ref="teamSelectorRef" @event-change-team="onChangeTeam"></team-select-selector>
            </div>
          </div>
        </div>
        <div class="text-right col-sm-12 px-0 mt-1 text-right">
          <button type="submit" class="btn skin primary-button mt-1" @click="createTeamMember">{{$t('add_team_to_user')}}</button>
        </div>
      </div>
    </form>

    <div class="row mt-3" v-show="this.userTeams!=null && this.userTeams.length>0">
      <basic-table ref="userTeamTable" enableedit="true" v-bind:responsive="true" tablecss="skin">
        <template slot="menu" scope="childDataScope">
          <a v-bind:href="'javascript:deleteTeamUser(' + childDataScope.row.Id + ')'" class="dropdown-item">{{$t('remove')}}</a>
        </template>
      </basic-table>
    </div>
    <div class="row mt-3" v-show="$store.getInstallationType() != 'Education'">
      <div class="col-sm-12 px-0 custom-form-label">
        {{$t('link_users_organisations')}} <info-note v-bind:text="$t('optionally_connecting_user_with_organisations')"></info-note>
      </div>
    </div>
    <form id="linkOrganisationWithUSerForm" name="linkOrganisationWithUSerForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
      <div class="row" v-show="$store.getInstallationType() != 'Education'">
        <div class="form-group col-sm-12 px-0">
          <div class="row">
            <div class="col-sm-12 mt-1">
              <select required class="form-control" v-bind:id="'select_assigned_Organisation_' +  getId()" v-on:change="onChange">
                <option value="" style="">{{$t('select_organisation')}}</option>
                <option v-for="Organisation in Organisations" v-bind:value="Organisation.Organisationid">
                  {{ Organisation.Organization }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="text-right col-sm-12 px-0 mt-1 text-right">
          <button type="submit" class="btn skin primary-button mt-1" @click="createOrganisationUser">{{$t('add_organisation_to_user')}}</button>
        </div>
      </div>
    </form>

    <div class="row mt-3" v-show="this.userOrganisations!=null && this.userOrganisations.length>0">
      <basic-table ref="userOrganisationTable" enableedit="true" v-bind:responsive="true">
        <template slot="menu" scope="childDataScope">
          <a v-bind:href="'javascript:deleteOrganisationUser(' + childDataScope.row.OrganisationUserId + ')'" class="dropdown-item">{{$t('delete')}}</a>
        </template>
      </basic-table>
    </div>



  </div>
</template>

<script>
  import BasicTable from '../tables/basic-table.vue'
  import InfoNote from '../notes/info-note.vue'
  import TeamSelector from '../team/team-select-selector'
  var fullname = "";
  let Organisations = [];
  var OrganisationId = -1;
  let userOrganisations = [];
  let userTeams = [];
  var buttontext = "";
  var groups = [];
  var email = "";
  export default {
    name: "add-Organisation-user",
    components: {
      InfoNote,
      BasicTable,
      TeamSelector
    },
    props: {
      user: {
        type: String,
        default: ""
      },
      role: {
        type: String,
        default: ""
      },
      isLoggedInUser: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        buttontext,
        OrganisationId,
        Organisations: [],
        userOrganisations: [],
        userTeams: [],
        groups,
        fullname,
        email,
        teamId: null,
        isGoogleCalendarEnable: false,
      };
    },
    methods: {
      setOverrideGoogleCalendarEnable(checked, val, value) {
        this.isGoogleCalendarEnable = checked;
      },
      async getUserSetting(user) {
        try {
          this.userTeams = [];
          this.$http.get('/api/Memberships/v1/User/Setting?username=' + user).then(async response => {
            this.isGoogleCalendarEnable = response.data.EnableGoogleCalendar;
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async createTeamMember() {
        if (this.teamId === null || this.teamId === undefined || this.teamId === '') return;
        var request = { name: this.user, teamId: this.teamId };
        try {
          var response = await this.$http.post(
            '/api/Teams/v1/Members',
            request
          ).then(async response => {
            //this.$emit('event-refresh-teammembers');
            this.getUserTeams(this.user);
          });

        } catch (err) {
          alert(err);
        }
      },
      onChangeTeam(teamid) {
        this.teamId = teamid;
        //this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },
      onChange() {
        this.OrganisationId = $('#select_assigned_Organisation_' + this.getId()).val();
      },
      async createOrganisationUser() {
        if (!$('#linkOrganisationWithUSerForm').valid())
          return false;
        this.OrganisationId = $('#select_assigned_Organisation_' + this.getId()).val();
        var request = { id: this.OrganisationId, user: this.user };

        try {
          var response = await this.$http.post(
            '/api/Organizations/v1/User',
            request
          ).then(async response => {
            this.getUserOrganisations(this.user);
          });

        } catch (err) {
          alert(err);
        }
      },
      async getUserOrganisations(user) {
        try {
          this.userOrganisations = [];
          this.$http.get('/api/Organizations/v1/User?user=' + user).then(async response => {
            this.userOrganisations = response.data;

            var headerdata = [
              { headername: this.$t('user_organisations'), columnname: "Organization", css: "", datahide: "", enabled: true, databreakpoints: "" }
            ];
            var tabledata = this.userOrganisations;
            this.$refs.userOrganisationTable.setData(headerdata, tabledata);
            this.$refs.userOrganisationTable.render();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async getUserTeams(user) {
        try {
          this.userTeams = [];
          this.$http.get('/api/Teams/v1/Members/ByUsername?username=' + user).then(async response => {
            this.userTeams = response.data;

            var headerdata = [
              { headername: this.$t('team'), columnname: "Name", css: "", datahide: "", enabled: true, databreakpoints: "" }
            ];
            var tabledata = this.userTeams;
            this.$refs.userTeamTable.setData(headerdata, tabledata);
            this.$refs.userTeamTable.render();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async getUserFullName(user) {
        try {
          this.userOrganisations = [];
          this.$http.get('/api/Memberships/v1/User/Fullname?user=' + user).then(async response => {
            this.fullname = response.data.fullName;
            this.email = response.data.email;

            $("#select_language_" + this.getId()).val(response.data.language);
            $("#select_language_" + this.getId()).trigger('change');

            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async getOrganisations() {
        try {
          this.Organisations = [];
          this.$http.get('/api/Organizations/v1').then(async response => {
            this.Organisations = response.data;

            if (this.Organisations !== null && this.Organisations.length > 0) {
              this.Organisations = this.Organisations.sort(function (a, b) {
                var x = a.Organization.toLowerCase();
                var y = b.Organization.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }

            $('#select_assigned_Organisation_' + this.getId()).select2();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async handleRefresh() {
        this.getUserOrganisations(this.user);
        this.getUserTeams(this.user);
      },
      async loadGroups() {
        try {
          var rootContentId = $('#hiddenRootContentId').val();
          var url = "/api/Users/v1/Roles";
          this.$http.get(url).then(async response => {
            this.groups = response.data;
            if (this.groups.length > 0) {
              // Find the index of the item with the specified id
              let index = this.groups.findIndex(item => item.Name === "SuperAdmin");              
              // If the item is found, remove it from the array
              if (index !== -1) {
                this.groups.splice(index, 1);
              }
            }
            $('#select_assigned_group_' + this.getId()).select2();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      async updateRole() {
        if (!$('#updateUserRoleform').valid())
          return false;
        if (this.fullname !== null && this.fullname !== undefined) {
          this.fullname = this.fullname.trim();
        }
        if (this.email !== null && this.email !== undefined) {
          this.email = this.email.trim();
        }
        var newRole = $('#select_assigned_group_' + this.getId()).val();
        var request = {
          newRole: newRole, oldRole: this.role, user: this.user,
          fullName: this.fullname,
          email: this.email, language: $('#select_language_' + this.getId()).val(),
          enableGoogleCalendar: this.isGoogleCalendarEnable,
        };

        try {
          var response = await this.$http.post(
            '/api/Memberships/v1/User/Role',
            request
          ).then(async response => {
            vm.$root.$emit('refreshview');
          })

        } catch (err) {

        }
      },
    },
    watch: {
      user: function (newVal, oldVal) {
        if (newVal !== "") {
          $("#select_language_" + this.getId()).val('');
          $("#select_language_" + this.getId()).trigger('change');
          this.getUserOrganisations(newVal);
          this.getUserFullName(newVal);
          this.getUserTeams(newVal);
          this.getUserSetting(newVal);
        }
      },
      role: function (newVal, oldVal) {
        if (!this.isLoggedInUser) {
          $("#select_assigned_group_" + this.getId()).val(newVal);
          $("#select_assigned_group_" + this.getId()).trigger('change');
        }
      },
      isLoggedInUser: function (newVal, oldVal) {
        $("#select_assigned_group_" + this.getId()).val(this.role);
        $("#select_assigned_group_" + this.getId()).trigger('change');
      }
    },
    mounted() {
      _componentValidation('#linkOrganisationWithUSerForm');

      var rules = {
        'email': {
          required: false,
          email: true
        }
      };
      _componentValidation('#updateUserRoleform', rules);

      if (this.user !== "" && this.user !== undefined && this.user !== null) {
        this.getUserOrganisations(this.user);
        this.getUserTeams(this.user);
      }
      this.loadGroups();
      this.buttontext = this.$t('add_organisation')
    }
  };


</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/user/add-organisation-user.vue